import { format } from 'date-fns';
import { getLocaleFromLanguageOrCurrent } from 'src/utils/localeUtils';

const DateFormatter = 'MMMM d, yyyy';

export const formatDate = (
  date: string | Date | undefined | null,
  formatStr: string = DateFormatter
): string => {
  if (!date) {
    return 'N/A';
  }
  const locale = getLocaleFromLanguageOrCurrent();
  return format(new Date(date), formatStr, { locale });
};

export const formatAmount = (amount: number, currency: string): string => {
  return `$ ${amount.toFixed(2)} ${currency}`;
};

export const formatAmountShort = (amount: number): string => {
  return `$ ${amount.toFixed(2)}`;
};
